import { Configuration, PublicClientApplication, AuthenticationScheme } from "@azure/msal-browser";

const getRedirectUri = () => {
  // Check if running locally
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "http://localhost:3000/auth/callback";
  }
  // Dev environment URI
  if (window.location.hostname === 'intentico-react-app-env-dev-automated-contact-intelligence.vercel.app') {
    return "https://intentico-react-app-env-dev-automated-contact-intelligence.vercel.app/auth/callback";
  }
  // Production URI
  return "https://intenti.co/auth/callback";
};


export const msalConfig: Configuration = {
  auth: {
    clientId: "5a919d41-d719-4f24-ab03-4c5cca543fb4",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: getRedirectUri(),
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  authenticationScheme: AuthenticationScheme.BEARER
};

// Create the MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Export an async function to initialize MSAL
export const initializeMsal = async () => {
  await msalInstance.initialize();
  return msalInstance;
};